import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/tet.ts
var add = "Aumenta";
var remove = "Hasai";
var removeAll = "Hasai Hotu";
var incomplete = "Deskulpa, iha informasaun neebe sala iha formuláriu";
var submit = "Submete";
var noFiles = "Seidauk hili file";
var moveUp = "Muda ba leten";
var moveDown = "Muda ba kotuk";
var isLoading = "Hein lai...";
var loadMore = "Foti tan";
var next = "Ba oin";
var prev = "Ba kotuk";
var addAllValues = "Aumenta hotu";
var addSelectedValues = "Aumenta buat neebe hili ona";
var removeAllValues = "Hasai hotu";
var removeSelectedValues = "Hasai buat neebe hili ona";
var chooseDate = "Hili data";
var changeDate = "Troka data";
var accepted = function({
  name
}) {
  return `Favor ida simu ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} tenki depoid ${date(args[0])}.`;
  }
  return `${sentence(name)} tenki iha futuru.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} bele uza letra deit.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} bele uza letra ka numeru deit.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} bele uza letra ka numeru deit.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} tenki antes ${date(args[0])}.`;
  }
  return `${sentence(name)} tenki antes ohin loron.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Informasaun nee la loos no la bele submete.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} tenki iha klaran entre ${a} no ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} la hanesan.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} la loos, favor ida hakerek tuir ${args[0]}`;
  }
  return "Informasaun nee la loos no la bele submete.";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} tenki iha ${date(args[0])} no ${date(args[1])} nia klaran`;
};
var email = "Favor hakerek endresu email neebe loos.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} la remata ho ${list(args)}.`;
};
var is = function({
  name
}) {
  return `la bele uza ${sentence(name)}.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} tenki iha letra ida ka liu.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} tenki badak liu ${max2} letra.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} tenki iha letra ${max2}.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} tenki iha letra ${min2} ka liu.`;
  }
  return `${sentence(name)} tenki iha letra ${min2} too ${max2}.`;
};
var matches = function({
  name
}) {
  return `la bele uza ${sentence(name)}.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `La bele iha ${args[0]} ka liu ${name}.`;
  }
  return `${sentence(name)} tenki kiik liu ka hanesan ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return `La bele simu 'format' ida.`;
  }
  return `${sentence(name)} tenki iha tipo: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Presiza ${args[0]} ${name} ka liu.`;
  }
  return `${name} tenki ${args[0]} ka liu.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `La bele uza “${value}” ba ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} tenki numeru.`;
};
var required = function({
  name
}) {
  return `Presiza ${sentence(name)}.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} la komesa ho ${list(args)}.`;
};
var url = function() {
  return `Favor hakerek URL neebe loos.`;
};
var invalidDate = "Data la loos.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  required,
  starts_with,
  url,
  invalidDate
};
var tet_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, confirm, date_after, date_before, date_between, date_format, tet_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, prev, remove, removeAll, removeAllValues, removeSelectedValues, required, starts_with, submit, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=tet.mjs.map